import { render, staticRenderFns } from "./objecttype.vue?vue&type=template&id=0f593f10&"
import script from "./objecttype.vue?vue&type=script&lang=js&"
export * from "./objecttype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports